import { render, staticRenderFns } from "./ListSubModality.vue?vue&type=template&id=2db8afa2"
import script from "./ListSubModality.vue?vue&type=script&lang=js"
export * from "./ListSubModality.vue?vue&type=script&lang=js"
import style0 from "./ListSubModality.vue?vue&type=style&index=0&id=2db8afa2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports